/* =========================================
   MODEL GALLERY — navegación por flechas y thumbnails
   Permite cambiar la foto principal del perfil de modelo
   con las flechas prev/next o haciendo clic en las miniaturas.
   (el lightbox de zoom sigue funcionando aparte,
    vía lightbox.js, con flechas/teclado)
========================================= */
function initModelGallery() {

    document.querySelectorAll('.model-gallery').forEach((gallery) => {

        const slides = gallery.querySelectorAll('.model-slide');
        const thumbs = gallery.querySelectorAll('.model-thumb');
        const prevBtn = gallery.querySelector('.model-gallery__prev');
        const nextBtn = gallery.querySelector('.model-gallery__next');
        const counter = gallery.querySelector('.model-gallery__count-current');

        if (!slides.length) return;

        let index = 0;

        const goTo = (newIndex) => {

            index = (newIndex + slides.length) % slides.length;

            slides.forEach((slide, i) => {
                slide.classList.toggle('active', i === index);
            });

            thumbs.forEach((thumb, i) => {
                thumb.classList.toggle('active', i === index);
            });

            if (counter) counter.textContent = index + 1;
        };

        prevBtn?.addEventListener('click', () => goTo(index - 1));
        nextBtn?.addEventListener('click', () => goTo(index + 1));

        thumbs.forEach((thumb) => {
            thumb.addEventListener('click', () => {
                goTo(parseInt(thumb.dataset.index, 10) || 0);
            });
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.model-gallery')) {
        initModelGallery();
    }
});